import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedPatientNavigatorConfiguration
} from "../App/Compositions/NavigatorConfigurations";
import {
  noConfirmationCenterSelectableBookingStepConfigurations,
  screeningStepConfigurations
} from "../App/Compositions/StepConfigurations";
import { Flow } from "./IFlow";

const noBookFlowName = "noBook";

/** Legacy flow name alias. Routes users with cached "noBook" sessions to the no-confirmation experience. */
class NoBookFlow extends Flow {
  static readonly flowName = noBookFlowName;

  constructor(isPatientPreQualified: boolean) {
    isPatientPreQualified
      ? super(noBookFlowName, { ...noConfirmationCenterSelectableBookingStepConfigurations }, [
          ...NoConfirmationPreQualifiedPatientNavigatorConfiguration
        ])
      : super(
          noBookFlowName,
          { ...screeningStepConfigurations, ...noConfirmationCenterSelectableBookingStepConfigurations },
          [...NoConfirmationDefaultNavigatorConfiguration]
        );
  }
}

export default NoBookFlow;
